import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import 'index.module.css';

import App from 'App';
import DefaultLayout from 'DefaultLayout';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import { EMPTY_STRING } from 'constants/shared';
import { ENG_URL, HOME_URL } from 'constants/navigation';
import { EN_LANG, FR_LANG } from 'components/langSwitcher/constants';
import { getPath, routes } from 'routes';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <BrowserRouter>
                <>
                    <Routes>
                        <Route path={HOME_URL} element={<App />} />
                        <Route path={ENG_URL} element={<App />} />

                        {/* French routes (default, no prefix) */}
                        <Route
                            path={`${HOME_URL}*`}
                            element={<DefaultLayout />}
                        >
                            {routes.map((route) => (
                                <Route
                                    key={`fr-${route.path}`}
                                    path={getPath(route.path, FR_LANG).replace(
                                        HOME_URL,
                                        EMPTY_STRING
                                    )}
                                    element={route.element}
                                />
                            ))}
                        </Route>

                        {/* English routes with /en prefix */}
                        <Route
                            path={`${ENG_URL}/*`}
                            element={<DefaultLayout />}
                        >
                            {routes.map((route) => (
                                <Route
                                    key={`en-${route.path}`}
                                    path={getPath(route.path, EN_LANG).replace(
                                        `${ENG_URL}/`,
                                        EMPTY_STRING
                                    )}
                                    element={route.element}
                                />
                            ))}
                        </Route>

                        {/* Fallback route */}
                        <Route
                            path="*"
                            element={<Navigate to={HOME_URL} replace />}
                        />
                    </Routes>
                </>
            </BrowserRouter>
        </I18nextProvider>
    </React.StrictMode>
);
